import React from "react";
const PaymentRuleComponent = () => {
  return (
    <>
      <p className="title">資金決済法に基づく表記</p>
      <div className="content-wrapper">
        <dl className="two-column-content">
          <dt>サービス提供事業者</dt>
          <dd>
            {" "}
            株式会社リアズ<br />
            〒532-0011<br />
            大阪市淀川区西中島5-14-10 新大阪トヨタビル4階
          </dd>
          <dt>支払可能金額等</dt>
          <dd>上限はありません。</dd>
          <dt>有効期限</dt>
          <dd>
            購入したポイントの有効期限は購入日を含め6ヶ月以内です。ただし弊社、利用規約に基づき、お客様のアカウントを停止し、購入済みのポイントを没収させることがあります。尚、サービスを退会されますと、購入ポイントは失効となりますので、ご注意ください。
          </dd>
          <dt>ご相談窓口</dt>
          <dd>
            お問合せ窓口(minera.fit.2312@gmail.com)からご連絡ください。<br/>
            対応可能時間：9時〜18時
          </dd>
          <dt>ご利用いただける<br /> サービス</dt>
          <dd>minera（ミネラ）のサービス内でご利用することができます。</dd>
          <dt>前払式支払手段 <br /> 利用の注意</dt>
          <dd>
            資金決済に関する法律に基づき払戻しが認められる場合を除き、原則として、払い戻しはいたしません。
          </dd>
          <dt>残高確認方法</dt>
          <dd>マイページの画面上部に表示される残高からご確認いただけます。</dd>
          <dt>利用規約等</dt>
          <dd>その他の事項については利用規約をご覧ください。<br /> (利用規約)</dd>
        </dl>
      </div>
    </>
  );
};
export default PaymentRuleComponent;